import { ref, onMounted, onUnmounted } from 'vue'

export function useModal() {
  const isModalOpen = ref(false)
  const openModal   = () => { isModalOpen.value = true }
  const closeModal  = () => { isModalOpen.value = false }
  const toggleModal = () => { isModalOpen.value = !isModalOpen.value }

  const handleEsc = (event) => {
    if (event.key === 'Escape' && isModalOpen.value) closeModal()
  }

  onMounted(() => window.addEventListener('keydown', handleEsc))
  onUnmounted(() => window.removeEventListener('keydown', handleEsc))

  return { isModalOpen, openModal, closeModal, toggleModal }
}
